import { render } from "./winner-of-fashion.vue?vue&type=template&id=f80d1600&scoped=true"
import script from "./winner-of-fashion.vue?vue&type=script&lang=js"
export * from "./winner-of-fashion.vue?vue&type=script&lang=js"

import "./winner-of-fashion.vue?vue&type=style&index=0&id=f80d1600&lang=css"
import "./winner-of-fashion.vue?vue&type=style&index=1&id=f80d1600&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80d1600"]])

export default __exports__